import mondaySdk from "monday-sdk-js";

import { getQueryParam } from "@/lib/include-all";

const monday = mondaySdk();
monday.setApiVersion("2023-10");

const STORAGE = sessionStorage;

const getDialogKey = () => {
  return `clonePlusDialog-${new Date().getTime()}`;
};
const showModalDialog = async (
  usageData: { dataJson: string },
  urlPath: string,
  width: string,
  height: string,
  onCloseCallback: (data?: { dataJson: string }) => void
) => {
  const dialogKey = getDialogKey();
  STORAGE.setItem(dialogKey, JSON.stringify(usageData));
  const urlParams: { [key: string]: string } = {};
  urlParams["clonePlusDialogKey"] = dialogKey;

  await monday.execute("openAppFeatureModal", { urlPath, urlParams, height, width }).then(() => {
    const item = STORAGE.getItem(dialogKey);
    if (item) {
      STORAGE.removeItem(dialogKey);
      onCloseCallback(JSON.parse(item) as { dataJson: string });
    } else {
      onCloseCallback();
    }
  });
};

const closeModalDialog = (data?: { dataJson: string }) => {
  const dialogKey = getQueryParam("clonePlusDialogKey");
  if (data) {
    STORAGE.setItem(dialogKey as string, JSON.stringify(data));
  }
  monday
    .execute("closeAppFeatureModal")
    .then(() => {})
    .catch(() => {});
};

const getUsageDataFromParent = () => {
  const dialogKey = getQueryParam("clonePlusDialogKey");
  const item = STORAGE.getItem(dialogKey as string);
  if (item) {
    const usageData = JSON.parse(item) as { dataJson: string };
    STORAGE.removeItem(dialogKey as string);
    return usageData;
  } else {
    return undefined;
  }
};

const openLinkInTab = (url: string) => {
  monday
    .execute("openLinkInTab", { url: url })
    .then(() => {})
    .catch(() => {});
};

export const clonePlusDialog = {
  showModalDialog,
  closeModalDialog,
  getUsageDataFromParent: getUsageDataFromParent,
  openLinkInTab,
};
